<template>
  <div
    v-click-outside="closeSearch"
    :class="{
      'border-stone-age': era === 'stoneAge',
      'border-bronze-age': era === 'bronzeAge',
      'border-minoan-era': era === 'minoanEra',
      'border-classic-greece': era === 'classicGreece',
      'border-early-rome': era === 'earlyRome',
      'border-roman-empire': era === 'romanEmpire',
      'border-byzantine-era': era === 'byzantineEra',
      'border-age-of-the-franks': era === 'ageOfTheFranks',
      'border-feudal-age': era === 'feudalAge',
      'border-iberian-era': era === 'iberianEra',
      'border-kingdom-of-sicily': era === 'kingdomOfSicily',
      'border-high-middle-ages': era === 'highMiddleAges',
      'border-early-gothic-era': era === 'earlyGothicEra',
      }"
    class="flex flex-col border-t"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div
      class="text-white hover:text-white py-4 px-6 select-none cursor-pointer transition duration-300 relative"
      @click="toggleOpen"
    >
      <div class="font-light uppercase font-oswald leading-none">
        {{ buildingData.title }}
      </div>
      <div
        class="absolute top-2 flex items-center h-8 bg-gray-roc rounded-lg cursor-pointer duration-300 transition-all right-2 overflow-hidden"
        :class="{
          'hidden': !isHover,
          'w-32': searchVisible,
          'w-8': !searchVisible
        }"
        @click="onSearchClick"
      >
        <input
          ref="searchField"
          v-model="searchText"
          maxlength="10"
          type="text"
          class="h-8 bg-gray-roc text-white opacity-90 relative z-10 focus:outline-none shadow-lg text-sm"
          :class="{
            'w-26 p-1': searchVisible,
            'w-0': !searchVisible,
          }"
          placeholder="Search"
          @keydown="onKeyDown"
        />
        <i
          v-if="!searchVisible"
          class="fas fa-search absolute right-2 z-20 text-white"
        />
        <span
          v-else
          class="absolute h-full w-6 z-20 text-white right-0 flex items-center justify-center"
          @click.stop="hideSearch"
        >
          <i
            class="fas fa-times"
          />
        </span>
      </div>
    </div>
    <div
      :class="{
        'hidden': !isOpen,
        'flex': isOpen,
      }"
      class="flex-col bg-gray-800 flex-grow overflow-y-auto h-1px"
    >
      <BuildingSubItem
        v-for="(item, index) in buildingData.items"
        :class="{
          'hidden': !itemVisibility[item.id]
        }"
        :key="buildingType + '_' + index"
        :era="era"
        :item="item"
        @click="selectBuilding"
      />
    </div>
  </div>
</template>

<script>
import BuildingSubItem from "@/components/Menu/BuildingSubItem.vue";
import {computed, ref} from 'vue';

export default {
  components: {
    BuildingSubItem
  },
  props: {
    buildingType: {
      type: String,
      required: true
    },
    buildingData: {
      type: Object,
      required: true
    },
    era: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ["select", "open"],
  setup(props, context) {
    const isHover = ref(false);
    const searchVisible = ref(false);
    const searchText = ref('');
    const searchField = ref(null);

    const matchesSearched = (name) => {
      if (searchText.value.trim() === '') {
        return true;
      }
      if (name.toLowerCase().startsWith(searchText.value.toLowerCase())) {
        return true;
      }
      return false;
    };

    return {
      searchText,
      searchVisible,
      isHover,
      searchField,

      itemVisibility: computed(() => {
        const result = {};
        for (let i = 0; i < props.buildingData.items.length; i++) {
          result[props.buildingData.items[i].id] = matchesSearched(props.buildingData.items[i].name);
        }
        return result;
      }),

      selectBuilding(templateId) {
        context.emit("select", templateId);
      },
      toggleOpen() {
        context.emit('open', props.buildingType);
      },
      onMouseEnter () {
        if (!searchVisible.value) {
          isHover.value = true;
          searchText.value = '';
        }
      },
      onMouseLeave () {
        if (!searchVisible.value) {
          isHover.value = false;
        }
      },
      onSearchClick () {
        searchVisible.value = true;
        setTimeout(() => {
          if (searchField.value) {
            searchField.value.focus();
          }
        }, 300);
      },
      closeSearch () {
        searchVisible.value = false;
        searchText.value = '';
        isHover.value = false;
      },
      hideSearch () {
        searchVisible.value = false;
        searchText.value = '';
      },
      onKeyDown (ev) {
        if (ev.key === 'Escape') {
          searchVisible.value = false;
          searchText.value = '';
        }
      }
    };
  }
};
</script>
